export const chat = {
  assistantName: 'Victor AI',
  statusOnline: 'Online',
  welcomeMessage:
    "Hi! I'm Victor's Assistant. I help you understand which solution fits you: Foundation for online presence or Launch for complete automation. Tell me, what does your company do?",
  messagePlaceholder: 'Type a message...',
  thinking: 'Thinking...',
  openChat: 'Open chat',
  typingStatus: 'AI thinking...',
  tabs: {
    info: 'Victor AI',
    email: 'Contact Form',
  },
  modes: {
    info: {
      welcome: {
        title: 'Meet Victor\'s Assistant',
        description:
          'Ask me about the Foundation or Launch plan, what are the differences, or how we can help your company grow online.',
      },
    },
    email: {
      title: 'Send me a message',
      description: 'Fill out the form below to get in touch directly with Victor.',
      form: {
        name: 'Your name',
        email: 'Your email',
        message: 'Your message',
        send: 'Send',
        sending: 'Sending...',
        success: 'Message sent successfully!',
        error: 'Failed to send message. Please try again.',
      },
    },
  },
  prompts: {
    services: 'What services do you offer?',
    foundation: 'Tell me more about the Foundation plan',
    launch: 'Tell me more about the Launch plan',
    contact: 'How can I speak directly with Victor?',
  },
  error: 'Error generating response',
  form: {
    title: 'Enter your contact information',
    name: 'Full name',
    email: 'Email',
    phone: 'Phone',
    company: 'Company',
    namePlaceholder: 'Your full name',
    emailPlaceholder: 'your@email.com',
    phonePlaceholder: '+1 555 123 4567',
    companyPlaceholder: 'Your company name',
    nameRequired: 'Name is required',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email',
    phoneRequired: 'Phone is required',
    phoneInvalid: 'Please enter a valid phone number',
    companyRequired: 'Company is required',
    fillAllFields: 'Please fill all fields correctly',
    saved: 'Information saved!',
    saveError: 'Error saving information',
    saveWarning: 'Information will be saved when the server is available',
    sending: 'Sending...',
    send: 'Send',
    submitError: 'Error submitting form',
  },
};